import { Utilisateur } from './utilisateur.model';

/**
 * Builder abstrait d'un utilisateur, nécessitant de connaitre le type de l'utilisateur concret à builder.
 */
export abstract class UtilisateurBuilder<U extends Utilisateur> {
	private login: string | undefined;
	private firstName: string | undefined;
	private lastName: string | undefined;
	private roles: string[] | undefined;
	private droits: string[] | undefined;
	private langue: string | undefined;

	/**
	 * Instancie l'utilisateur concret à builder.
	 * @returns l'instance de l'utilisateur concret.
	 */
	abstract instancierUtilisateur(): U;

	setLogin(login: string): this {
		this.login = login;
		return this;
	}

	setFirstName(firstName: string): this {
		this.firstName = firstName;
		return this;
	}

	setLastName(lastName: string): this {
		this.lastName = lastName;
		return this;
	}

	setRoles(roles: string[]): this {
		this.roles = roles;
		return this;
	}

	setLangue(langue: string): this {
		this.langue = langue;
		return this;
	}

	setDroits(droits: string[]): this {
		this.droits = droits;
		return this;
	}

	/**
	 * Build l'utilisateur concret.
	 * @returns l'utilisateur concret.
	 */
	build(): U {
		const utilisateur: U = this.instancierUtilisateur();

		utilisateur.login = this.login;
		utilisateur.firstName = this.firstName;
		utilisateur.lastName = this.lastName;
		utilisateur.roles = this.roles;
		utilisateur.langue = this.langue;

		utilisateur.initialiserDroits();
		this.droits?.forEach(droit => utilisateur.droits[droit] = true);

		return utilisateur;
	}
}
